import { FormError } from "@3gaam/shared/types/error";
import React, { InputHTMLAttributes } from "react";

type ChangeEvent = React.ChangeEvent & {
  target: { [name: string]: string | boolean };
};

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> & {
  error?: FormError;
  value: boolean;
  label?: string | null;
  onChange: (e: ChangeEvent) => void;
};
const SwitchField = ({
  onChange,
  name,
  value,
  label,
  className = "",
  children,
  error,
}: Props) => {
  let showError = name && error?.hasError && error?.dataError?.[name];
  return (
    <>
      <div
        className={`inp-box d-flex flex-shrink-0 ${
          showError ? "invalid-field" : ""
        } ${className}`}
      >
        <div className="d-flex flex-shrink-0">
          <label className="mmp-switch mb-0">
            <input
              type="checkbox"
              name={name}
              checked={value}
              //@ts-ignore
              onChange={(e) => onChange(e)}
              className="custom-control-input"
              id={name}
            />
            <span className="slider round"></span>
          </label>
          {label && (
            <label className="mr-2" htmlFor={name}>
              {label}
            </label>
          )}
        </div>
        {children}
      </div>
      {showError && name && (
        <p className="text-red font-12 mt-1">{error?.dataError?.[name]}</p>
      )}
    </>
  );
};

export default SwitchField;
